import videojs from "video.js";
import "videojs-flash";
import hlsjsHandleErrors from "hlsjs_handle_errors";
import "hlsjs";

/* global Hls */

export default function initHls() {
  console.log("hls.js");
  const HlsjsSourceHandler = function() {
    // console.log("Hello");
    return {
      initHls(player) {
        const hls = new Hls();
        // const hls = new Hls({
        //   xhrSetup(xhr) {
        //     xhr.withCredentials = true;
        //   },
        //   fetchSetup(context, initParams) {
        //     initParams.credentials = "include";
        //     return new Request(context.url, initParams);
        //   },
        // });
        hlsjsHandleErrors(hls, player);

        // hls.on(Hls.Events.AUDIO_TRACKS_UPDATED, (event, data) => {
        //   data.audioTracks.forEach(track => {
        //     player.audioTracks().addTrack(
        //       new videojs.AudioTrack({
        //         id: track.id,
        //         kind: "translation",
        //         label: track.name,
        //         language: track.lang,
        //       }),
        //     );
        //   });
        //   const audioTrackList = player.audioTracks();
        //   audioTrackList.addEventListener("change", () => {
        //     for (let i = 0; i < audioTrackList.length; i++) {
        //       const track = audioTrackList[i];

        //       if (track.enabled) {
        //         hls.audioTrack = hls.audioTracks.find(
        //           trackhls => trackhls.lang === track.language,
        //         ).id;
        //         return;
        //       }
        //     }
        //   });
        // });

        return hls;
      },

      canHandleSource(src) {
        return this.canPlayType(src.type);
      },
      handleSource(source, tech, options = {}) {
        if (!tech.hls) {
          tech.hls = this.initHls(tech.player_);
        }
        tech.hls.loadSource(source.src);
        tech.hls.attachMedia(options.el);
        tech.hls.controls = true;
        // tech.hls.currentLevel = 2;
        // tech.hls.loadLevel = 2;
        return tech.hls;
      },
      canPlayType(type) {
        return "maybe";
      },
    };
  };
  // console.log(videojs.getTech("Html5"))
  videojs
    .getTech("Html5")
    .registerSourceHandler(HlsjsSourceHandler("html5"), 0);
  } 




// WEBPACK FOOTER //
// ./src/js/hlsjs/videojs_source_handler.js